import { FC, useState } from "react";
import toast from "react-hot-toast";
import useOrder, { TTrackingErrors, TTrackingState } from "../../../hooks/useOrder";
import { IOrder } from "../../../model/IOrder";
import { msg } from "../../../msg";
import TrackingWidget from "./TrackingWidget";

/** One carrier and tracking number across every item on the order. */
const TrackingProductsWidget: FC<{ order: IOrder }> = ({ order }) => {
  const [errState, setErrState] = useState<TTrackingErrors>();
  const { patchAllProductsTrackings, loading } = useOrder();
  const [isModal, setIsModal] = useState<boolean>(false);

  const addTracking = async (state: TTrackingState) => {
    setErrState(() => undefined);
    const errs = await patchAllProductsTrackings(state, order);
    if (errs) setErrState(() => errs);
    else {
      toast.success(msg('success-tracking-products-adding'), { duration: 5000 });
      setIsModal(() => false);
    }
  };

  // -- Deliberately opens blank. The items may carry different carriers, and
  // -- seeding from one of them would make overwriting the rest look like a
  // -- confirmation of what is already there.
  return (
    <TrackingWidget
      errors={errState}
      loading={loading}
      title="Edit Tracking Information for All Products"
      buttonTitle="Edit Tracking Information for ALL products"
      onClick={addTracking}
      isShown={isModal}
      setIsShown={setIsModal}
    />
  );
};

export default TrackingProductsWidget;
